module.exports = __webpack_public_path__ + "static/1289797791.114c91e4.jpg";